export default __webpack_public_path__ + "static/img_1-43b81e02af711f90db181531387e6674.jpg";